module.exports = __webpack_public_path__ + "img/age02.166fba1d.png";